import React, { useEffect, useState } from "react";
import "../Styles/ViewStudentRegistration.css";
import { useNavigate } from "react-router-dom";

import {
  FaFilter,
  FaSearch,
  FaEnvelope,
  FaDownload,
  FaTrash,
  FaCommentDots,
} from "react-icons/fa";

import { IoLogoWhatsapp } from "react-icons/io";

import { saveAs } from "file-saver";
import { Document, Packer, Paragraph, TextRun } from "docx";

import Studentfilter from "../components/AdminDashboard/Studentfilter";

import ApiService from "../nhrc_apis/ApiService";

const { AdminAPI } = ApiService;

function ViewStudentRegistration() {
  const navigate = useNavigate();

  const [employees, setEmployees] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedIds, setSelectedIds] = useState([]);
  const [page, setPage] = useState(1);
  const [openFilter, setOpenFilter] = useState(false);

  const [sendOptions, setSendOptions] = useState({
    email: false,
    whatsapp: false,
    message: false,
  });

  const recordsPerPage = 10;

  /* =========================
     LOAD ONLY APPROVED STUDENTS
  ========================== */
  useEffect(() => {
    fetchApprovedStudents();
  }, []);

  const fetchApprovedStudents = async () => {
    try {
      const res = await AdminAPI.getStudents();

      console.log("STUDENT API RESPONSE =>", res.data);

      const list =
        res.data?.data ||
        res.data?.students ||
        res.data ||
        [];

      /*
        API FORMAT:
        {
          member:{},
          details:{}
        }
      */

      const approvedStudents = list
        .filter((item) => {
          const member = item.member || item;

          return (
            member?.status &&
            member.status.toLowerCase() === "approved"
          );
        })
        .map((item, index) => {
          const member = item.member || {};
          const details = item.details || {};

          return {
            id:
              member.membership_id ||
              member.id ||
              details.member_id ||
              index,

            membershipId:
              member.membership_id ||
              member.id,

            name:
              member.full_name ||
              "",

            phone:
              member.mobile ||
              "",

            email:
              member.email ||
              "",

            university:
              details.university_name ||
              "",

            state:
              member.state ||
              "",

            college:
              details.college_name ||
              "",

            department:
              details.department ||
              "",

            qualification:
              details.qualification ||
              "",

            startYear:
              details.start_year ||
              "",

            endYear:
              details.end_year ||
              "",

            district:
              member.district ||
              "",

            gender:
              member.gender ||
              "",

            bloodGroup:
              member.blood_group ||
              "",

            pincode:
              member.pincode ||
              "",

            candidateType:
              member.candidate_type ||
              "",

            status:
              member.status ||
              "",

            photo: member.profile_pic
              ? member.profile_pic.startsWith("http")
                ? member.profile_pic
                : `https://nhrc.onrender.com/${member.profile_pic}`
              : "https://via.placeholder.com/40",

            fullData: item,
          };
        });

      setEmployees(approvedStudents);
    } catch (err) {
      console.error("ERROR FETCHING STUDENTS =>", err);
      alert("Failed to load students");
    }
  };

  /* =========================
     SEARCH
  ========================== */
  const filtered = employees.filter((emp) => {
    const term = searchTerm.toLowerCase();

    return (
      emp.name.toLowerCase().includes(term) ||
      emp.email.toLowerCase().includes(term) ||
      emp.phone.toLowerCase().includes(term) ||
      emp.university.toLowerCase().includes(term) ||
      emp.college.toLowerCase().includes(term) ||
      emp.state.toLowerCase().includes(term) ||
      emp.department.toLowerCase().includes(term) ||
      emp.qualification.toLowerCase().includes(term) ||
      String(emp.id).toLowerCase().includes(term)
    );
  });

  /* =========================
     PAGINATION
  ========================== */
  const paginated = filtered.slice(
    (page - 1) * recordsPerPage,
    page * recordsPerPage
  );

  const totalPages = Math.ceil(filtered.length / recordsPerPage) || 1;

  /* =========================
     SELECT ALL
  ========================== */
  const toggleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedIds(paginated.map((emp) => emp.id));
    } else {
      setSelectedIds([]);
    }
  };

  /* =========================
     SINGLE SELECT
  ========================== */
  const toggleSelect = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id)
        ? prev.filter((sid) => sid !== id)
        : [...prev, id]
    );
  };

  /* =========================
     DELETE
  ========================== */
  const handleDeleteSelected = () => {
    if (!selectedIds.length) {
      alert("Select at least one student");
      return;
    }

    setEmployees((prev) =>
      prev.filter((emp) => !selectedIds.includes(emp.id))
    );

    setSelectedIds([]);
  };

  /* =========================
     SEND
  ========================== */
  const handleSendMessages = () => {
    if (!selectedIds.length) {
      alert("Select at least one student");
      return;
    }

    const channels = [];

    if (sendOptions.email) channels.push("Email");
    if (sendOptions.whatsapp) channels.push("WhatsApp");
    if (sendOptions.message) channels.push("Message");

    if (!channels.length) {
      alert("Select communication method");
      return;
    }

    alert(`Sending via ${channels.join(", ")}`);
  };

  /* =========================
     DOWNLOAD DOC
  ========================== */
  const handleDownloadSelected = async () => {
    if (!selectedIds.length) {
      alert("Select students");
      return;
    }

    const selectedStudents = employees.filter((emp) =>
      selectedIds.includes(emp.id)
    );

    for (const emp of selectedStudents) {
      const doc = new Document({
        sections: [
          {
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Approved Student Details",
                    bold: true,
                    size: 32,
                  }),
                ],
              }),

              new Paragraph(`Member ID: ${emp.id}`),
              new Paragraph(`Name: ${emp.name}`),
              new Paragraph(`Email: ${emp.email}`),
              new Paragraph(`Phone: ${emp.phone}`),
              new Paragraph(`University: ${emp.university}`),
              new Paragraph(`College: ${emp.college}`),
              new Paragraph(`Department: ${emp.department}`),
              new Paragraph(`Qualification: ${emp.qualification}`),
              new Paragraph(`Start Year: ${emp.startYear}`),
              new Paragraph(`End Year: ${emp.endYear}`),
              new Paragraph(`State: ${emp.state}`),
              new Paragraph(`District: ${emp.district}`),
              new Paragraph(`Gender: ${emp.gender}`),
              new Paragraph(`Blood Group: ${emp.bloodGroup}`),
              new Paragraph(`Pincode: ${emp.pincode}`),
              new Paragraph(`Candidate Type: ${emp.candidateType}`),
              new Paragraph(`Status: ${emp.status}`),
            ],
          },
        ],
      });

      const blob = await Packer.toBlob(doc);

      saveAs(blob, `${emp.name}_Details.docx`);
    }
  };

  return (
    <div className="empviewstu-container">

      {/* ================= HEADER ================= */}
      <div className="empviewstu-header-bar">
        <h2>STUDENT REGISTRATION</h2>

        <p>
          Total Approved Students: <b>{employees.length}</b>
        </p>
      </div>

      {/* ================= ACTION BAR ================= */}
      <div className="empview-action-bar">

        <button
          className="empview-filter-btn"
          onClick={() => setOpenFilter(true)}
        >
          <FaFilter /> Filter
        </button>

        <div className="empview-search-box">
          <FaSearch />

          <input
            type="text"
            placeholder="Search students..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <button
          className="empview-delete-btn"
          onClick={handleDeleteSelected}
        >
          <FaTrash /> Delete
        </button>
      </div>

      {/* ================= TOOLBAR ================= */}
      <div className="empview-toolbar">

        <label>{selectedIds.length} Selected</label>

        <label>
          <input
            type="checkbox"
            checked={sendOptions.email}
            onChange={() =>
              setSendOptions((prev) => ({
                ...prev,
                email: !prev.email,
              }))
            }
          />
          <FaEnvelope /> Email
        </label>

        <label>
          <input
            type="checkbox"
            checked={sendOptions.whatsapp}
            onChange={() =>
              setSendOptions((prev) => ({
                ...prev,
                whatsapp: !prev.whatsapp,
              }))
            }
          />
          <IoLogoWhatsapp /> WhatsApp
        </label>

        <label>
          <input
            type="checkbox"
            checked={sendOptions.message}
            onChange={() =>
              setSendOptions((prev) => ({
                ...prev,
                message: !prev.message,
              }))
            }
          />
          <FaCommentDots /> Message
        </label>

        <button
          className="empview-download-btn"
          onClick={handleDownloadSelected}
        >
          <FaDownload /> Download
        </button>

        <button
          className="empview-send-btn"
          onClick={handleSendMessages}
        >
          Send
        </button>
      </div>

      {/* ================= TABLE ================= */}
      <div className="empview-table-container">

        <table className="empview-table">

          <thead>
            <tr>

              <th>
                <input
                  type="checkbox"
                  onChange={toggleSelectAll}
                  checked={
                    paginated.length > 0 &&
                    paginated.every((emp) =>
                      selectedIds.includes(emp.id)
                    )
                  }
                />
              </th>

              <th>Member ID</th>
              <th>Profile</th>
              <th>Name</th>
              <th>Phone</th>
              <th>University</th>
              <th>State</th>
              <th>College</th>
              <th>Actions</th>

            </tr>
          </thead>

          <tbody>

            {paginated.length > 0 ? (
              paginated.map((emp) => (
                <tr key={emp.id}>

                  <td>
                    <input
                      type="checkbox"
                      checked={selectedIds.includes(emp.id)}
                      onChange={() => toggleSelect(emp.id)}
                    />
                  </td>

                  <td>{emp.id}</td>

                  <td>
                    <img
                      src={emp.photo}
                      alt={emp.name}
                      className="empview-profile-pic"
                    />
                  </td>

                  <td>{emp.name}</td>

                  <td>{emp.phone}</td>

                  <td>{emp.university}</td>

                  <td>{emp.state}</td>

                  <td>{emp.college}</td>

                  <td>
                    <button
                      className="empview-view-btn"
                      onClick={() =>
                        navigate("/dashboard/StudentregView", {
                          state: {
                            membershipId:
                              emp.membershipId || emp.id,
                          },
                        })
                      }
                    >
                      View Details
                    </button>
                  </td>

                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className="text-center">
                  No approved students found
                </td>
              </tr>
            )}

          </tbody>

        </table>
      </div>

      {/* ================= PAGINATION ================= */}
      <div className="empview-pagination">

        <button
          disabled={page === 1}
          onClick={() => setPage(page - 1)}
        >
          Previous
        </button>

        <span>
          Page {page} of {totalPages}
        </span>

        <button
          disabled={page === totalPages}
          onClick={() => setPage(page + 1)}
        >
          Next
        </button>

      </div>

      {/* ================= FILTER ================= */}
      {openFilter && (
        <div className="filter-sidebar">
          <Studentfilter />
        </div>
      )}

    </div>
  );
}

export default ViewStudentRegistration;